export default "__VITE_ASSET__D9V16Bz2__"